import { Dialog, DialogBody } from "@material-tailwind/react";
import loadingImg1 from "../../assets/images/loader/loader1.gif";
import loadingImg2 from "../../assets/images/loader/loader2.gif";
import loadingImg3 from "../../assets/images/loader/loader3.gif";
import { useEffect, useState } from "react";

const textList = [
  "Preparing your PsiloScore assessment...",
  "Checking your current medications for safety...",
  "Assessing the severity of existing conditions...",
  "Analyzing your current mental health status...",
  "Understanding your goals for psilocybin therapy...",
  "Crunching the numbers to determine your PsiloScore...",
  "Developing personalized safety guidelines...",
];

export default function EngagingModal({ showResults, setShowResults }) {
  const [loaderText, setloaderText] = useState(textList[0]);
  const [loaderImg, setLoaderImg] = useState(null);
  const [loadingTime, setLoadingTime] = useState(0);
  const toggle = () => setShowResults(!showResults);
  const [progress, setProgress] = useState(0);

  function getRandomLoader(arr) {
    if (arr.length === 0) {
      return null;
    }
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress === 100) {
          clearInterval(interval);
          return prevProgress;
        }
        return prevProgress + 1;
      });
    }, 50);

    return () => {
      clearInterval(interval);
    };
  }, []);
  useEffect(() => {
    function renderText(textList) {
      let index = 1;
      const interval = setInterval(() => {
        if (index < textList.length) {
          setloaderText(textList[index]);
          index++;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    }
    showResults && renderText(textList);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingTime((prevCounter) => prevCounter + 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);
  useEffect(() => {
    setLoaderImg(getRandomLoader([loadingImg1, loadingImg2, loadingImg3]));
  }, []);

  return (
    <Dialog open={showResults} handler={toggle} size="lg" className="w-full">
      <DialogBody className="p-0">
        <div className="flex justify-end items-center">
          <span className="flex py-2 px-3 bg-secondary text-white">
            <span>{loadingTime}</span>
            <span className="ms-2">seconds</span>
          </span>
        </div>
        <div className="agn-counter-section my-2 py-4 mx-0">
          <div className="container">
            <div className="grid grid-cols-2 gap-4">
              <div className="main-wrapper pb-0">
                <div className="theme-title-one text-center p-0 flex flex-col justify-center items-center">
                  <img
                    src={loaderImg}
                    alt="thinking"
                    className="w-[300px] h-[300px]"
                  />
                </div>
              </div>
              <div>
                <h4 className="underline">
                  Purchase Detailed Report and Unlock valuable benefits:
                </h4>
                <ul className="list-none text-sm border-t-0 py-0 mt-2">
                  <li className="flex items-center">
                    <i className="fa fa-check mr-2"></i>
                    <span>
                      Improves user experience by reducing anxiety and providing
                      value during wait times.
                    </span>
                  </li>
                  <li className="flex items-center">
                    <i className="fa fa-check mr-2"></i>
                    <span>
                      Increases opportunities for collecting user data and
                      preferences.
                    </span>
                  </li>
                  <li className="flex items-center">
                    <i className="fa fa-check mr-2"></i>
                    <span>
                      Potential to improve conversion rates for detailed report
                      purchases.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex justify-center items-center">
              <span>{loaderText}</span>
            </div>
          </div>
        </div>
      </DialogBody>
    </Dialog>
  );
}
